@if (label) {
  <label for="{{ id }}" [attr.id]="labelId" (bbKeyboardClick)="onFocus($event)" class="form-label">{{ label }}</label>
}
<div
  #searchBox
  [attr.role]="containerRole"
  [attr.aria-label]="containerAriaLabel"
  class="bb-search-box input-group form-control-wrapper"
  [ngClass]="[
    showSearch ? 'bb-search-box--has-search' : '',
    showSearch || showClear ? 'bb-search-box-visible' : '',
    isClearVisible() ? 'bb-search-box--has-clear' : '',
    typeaheadOptions && typeaheadOptions.groupCssClasses ? typeaheadOptions.groupCssClasses : '',
    getKeywordBySize(size) ? 'bb-search-box--' + getKeywordBySize(size) : '',
    readonly ? 'bb-search-box--readonly' : ''
  ]"
>
  @if (showSearch) {
    <button
      #searchButton
      bbButton
      [attr.data-id]="id ? id + '_search-box_search-button' : undefined"
      [attr.data-role]="'bb-search-button'"
      (click)="onSubmit()"
      color="tertiary"
      [buttonSize]="getKeywordBySize(size)"
      [attr.aria-label]="searchLabel"
      [disabled]="disabled"
    >
      <bb-icon-ui name="search" [size]="size"></bb-icon-ui>
    </button>
  }
  @if (typeaheadOptions) {
    <input
      #inputField
      type="search"
      inputmode="search"
      id="{{ id }}"
      class="bb-search-box__input form-control"
      aria-haspopup="listbox"
      [ngClass]="[size ? 'form-control-' + getKeywordBySize(size) : '', inputClassName ? inputClassName : '']"
      [placeholder]="placeholder"
      [readOnly]="readonly"
      [disabled]="disabled"
      [attr.aria-disabled]="disabled"
      [attr.aria-autocomplete]="ariaAutocomplete"
      [attr.aria-controls]="ngbTypeahead?.popupId"
      [attr.aria-label]="ariaLabel"
      [attr.aria-describedby]="ariaDescribedby"
      [attr.aria-labelledby]="ariaLabelledby"
      [attr.aria-expanded]="ariaExpanded"
      [attr.role]="role || 'combobox'"
      [attr.aria-invalid]="ariaInvalid"
      [attr.aria-owns]="ariaOwns"
      [attr.aria-activedescendant]="ariaActivedescendant"
      [attr.maxlength]="maxLength"
      [ngModel]="value"
      (ngModelChange)="onValueChange($event)"
      [ngbTypeahead]="$safeNavigationMigration(typeaheadOptions?.ngbTypeahead)"
      [popupClass]="'bb-block--full-width'"
      [editable]="typeaheadOptions?.editable !== false"
      [focusFirst]="typeaheadOptions?.focusFirst !== false"
      [showHint]="typeaheadOptions?.showHint === true"
      [placement]="placementTypeahead"
      [inputFormatter]="$safeNavigationMigration(typeaheadOptions?.inputFormatter)"
      [resultFormatter]="$safeNavigationMigration(typeaheadOptions?.resultFormatter)"
      [resultTemplate]="$safeNavigationMigration(typeaheadOptions?.resultTemplate)"
      [popperOptions]="popperOptions"
      [required]="required"
      [bbFocus]="autofocus"
      (selectItem)="onSelect($event)"
      (focus)="onFocus($event)"
      (blur)="onBlur($event)"
      (keyup.enter)="onSubmit()"
      [attr.data-role]="'search-input'"
      [autocomplete]="autocomplete"
    />
  } @else {
    <input
      #inputField
      type="search"
      inputmode="search"
      [attr.id]="id"
      [attr.aria-autocomplete]="ariaAutocomplete"
      [attr.aria-label]="ariaLabel"
      [attr.aria-describedby]="ariaDescribedby"
      [attr.aria-labelledby]="ariaLabelledby"
      [attr.aria-expanded]="ariaExpanded"
      [attr.role]="role || 'searchbox'"
      [attr.aria-invalid]="ariaInvalid"
      [attr.aria-owns]="ariaOwns"
      [attr.aria-activedescendant]="ariaActivedescendant"
      [attr.aria-disabled]="disabled"
      class="bb-search-box__simple-input form-control"
      [placeholder]="placeholder"
      [attr.maxlength]="maxLength"
      [ngModel]="value"
      [readOnly]="readonly"
      [required]="required"
      [disabled]="disabled"
      [bbFocus]="autofocus"
      (ngModelChange)="onValueChange($event)"
      (keyup.enter)="onSubmit()"
      (focus)="onFocus($event)"
      (blur)="onBlur($event)"
      [attr.data-role]="'search-input'"
      [ngClass]="[size ? 'form-control-' + getKeywordBySize(size) : '', inputClassName ? inputClassName : '']"
      [autocomplete]="autocomplete"
    />
  }
  @if (isClearVisible()) {
    <button
      bbButton
      [attr.data-id]="id ? id + '_search-box_clear-button' : undefined"
      [attr.data-role]="'bb-clear-button'"
      (click)="onClear()"
      color="tertiary"
      [attr.aria-label]="clearLabel"
      [buttonSize]="getKeywordBySize(size)"
      [disabled]="disabled"
    >
      <bb-icon-ui name="cancel" size="sm"></bb-icon-ui>
    </button>
  }
  <ng-content></ng-content>
</div>
